import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "edit-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.374 5.87452C13.6669 5.5816 14.1417 5.58157 14.4347 5.87444L17.7711 9.21038C18.064 9.50325 18.064 9.97812 17.7712 10.271C17.4783 10.564 17.0034 10.564 16.7105 10.2711L13.3741 6.93518C13.0812 6.64231 13.0811 6.16743 13.374 5.87452Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.3 3.94995C17.2552 3.94995 17.1942 3.96645 17.1303 4.03028L3.83033 17.3303C3.77461 17.386 3.76264 17.4119 3.76036 17.4171C3.75903 17.4199 3.75 17.4395 3.75 17.5V20.0499H6.2C6.26045 20.0499 6.27977 20.041 6.28266 20.0397C6.28779 20.0374 6.31395 20.0253 6.36967 19.9696L19.6697 6.66962C19.7335 6.60579 19.75 6.54478 19.75 6.49995C19.75 6.45512 19.7335 6.39412 19.6697 6.33028L19.658 6.31837L17.4653 4.02597C17.403 3.9657 17.3438 3.94995 17.3 3.94995ZM16.0697 2.96962C16.7626 2.27673 17.8374 2.27673 18.5303 2.96962L18.542 2.98153L20.7369 5.27623C21.4232 5.96934 21.421 7.03959 20.7303 7.73028L7.43033 21.0303C7.28605 21.1746 7.11198 21.3126 6.8921 21.4103C6.66897 21.5095 6.43751 21.5499 6.2 21.5499H3C2.58579 21.5499 2.25 21.2142 2.25 20.7999V17.5C2.25 17.2624 2.29047 17.031 2.38964 16.8078C2.48736 16.588 2.62539 16.4139 2.76967 16.2696L16.0697 2.96962Z"
    }, null, -1)
  ])))
}
export default { render: render }